import { Link } from 'react-router';
import { Icon } from '@/comp/icon/icon';
import { useContext, useEffect, useMemo, useState } from 'react';
import { AppContext } from '@/context/AppContext';
import { affiliate_checkIsAllowToBookService } from '@/_helper/checkAccess';
import ExtraServices from '@/pages/extra-services';
import InfoCard from '@/comp/ui/infoCard/infoCard';
import * as storage from '@/_helper/storage';

export const ExtraServicesOptions = () => {
    const { bookingData, saveBookingData } = useContext(AppContext);
    const [isLoaded, setIsLoaded] = useState(false);
    const service = 'extraServices';

    const showButton = useMemo(() => {
        return Object.values(window.$content.extras).some(({ active }) => active);
    }, []);

    useEffect(() => {
        if (bookingData && bookingData?.['load-extraservices'] === undefined) {
            bookingData['load-extraservices'] = true;
            storage.set('bookingData', bookingData);
            saveBookingData(bookingData);
        }
    }, [bookingData, saveBookingData]);

    useEffect(() => {
        if (showButton && !window.deactivateServices.includes('ExtraServices')) {
            if (!isLoaded) {
                setIsLoaded(false);
            }
        }
    }, [showButton, isLoaded]);

    if ((window.$affiliate && !affiliate_checkIsAllowToBookService(service).includes(service)) || !bookingData) {
        return null;
    }

    return (
        <div className="tab-content-container extra-services">
            {window.$browserInfo.device === 'mobile' && <div className="modal-mobile-background-layer"></div>}
            <div className="tab-header">
                <h3>Zusatzleistungen</h3>
                {window.$browserInfo.device === 'mobile' && (
                    <Link rel="noopener noreferrer" className="modal-close" to={'/'}>
                        <Icon name="close" ariaLabel="overlay schließen" />
                    </Link>
                )}
            </div>
            <div className="tab-content">
                {showButton && <ExtraServices />}
                {!showButton && (
                    <InfoCard type="large">
                        Für Ihre Reise sind im Moment leider keine Zusatzleistungen verfügbar.
                    </InfoCard>
                )}
                <div className="info-text">
                    Wenn Sie an Ihrer Buchung eine Änderung vornehmen möchten klicken Sie{' '}
                    <Link rel="noopener noreferrer" className="link" to={'/buchung-verwalten'}>
                        hier
                    </Link>
                    .
                </div>
            </div>
        </div>
    );
};
